<svg style="display: none" version="2.0">
  <defs>
    <symbol id="ag-award" class="ag-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="currentColor">
        <path
          d="M7.346 14.205 4.893 21.49a4.245 9.854 18.604 0 1 2.217-.451 4.245 9.854 18.604 0 1 1.5 1.677l.837-2.487V16.2c-.03-.008-.053-.008-.084-.018-1.216-.38-.929-1.212-1.968-1.948-.017-.012-.032-.018-.049-.029zM16.597 14.257c-.825.722-.633 1.477-1.77 1.86-.103.036-.192.05-.284.068v4.236l.773 2.296a9.854 4.245 71.396 0 1 1.5-1.678 9.854 4.245 71.396 0 1 2.216.452z"
        />
        <path
          d="M-230.42 370.98c-17.196.203-23.553 9.058-35.478 9.871v132.49a73.433 170.46 0 0 1 33.849-19.642 73.433 170.46 0 0 1 33.849 19.233v-133.47c-9.858-1.844-16.794-8.664-32.221-8.482z"
          paint-order="markers stroke fill"
          style="font-variation-settings: normal"
          transform="translate(25.411 -5.748) scale(.05781)"
        />
        <path
          d="M14 .042c-.792-.083-1.082.504-2.088.516-1.15.014-1.382-.746-2.471-.378-1.09.368-.813 1.113-1.735 1.8s-1.557.208-2.222 1.146-.003 1.378-.345 2.476C4.796 6.7 4 6.686 4.015 7.836c.013 1.15.807 1.117 1.176 2.206.368 1.09-.283 1.545.403 2.467.687.923 1.31.429 2.248 1.094.939.665.68 1.416 1.778 1.759 1.097.342 1.311-.423 2.461-.437 1.15-.013 1.382.747 2.471.379 1.09-.368.813-1.114 1.735-1.8s1.557-.209 2.222-1.147c.665-.938.003-1.378.346-2.476.342-1.098 1.137-1.083 1.123-2.233-.014-1.15-.807-1.117-1.175-2.206-.369-1.09.283-1.545-.404-2.468-.687-.922-1.31-.429-2.249-1.094-.938-.665-.679-1.416-1.776-1.759A1.923 1.923 0 0 0 14 .041zm-.508 1.95c.085.01.177.029.28.06.819.257.625.817 1.326 1.314.7.496 1.165.128 1.678.816.513.689.026 1.029.301 1.842.275.814.868.79.878 1.648.01.858-.583.847-.838 1.667-.256.82.238 1.148-.259 1.848-.496.7-.97.344-1.658.856-.69.513-.482 1.07-1.295 1.344-.814.275-.987-.293-1.845-.283-.859.01-1.018.582-1.838.327-.82-.256-.626-.817-1.327-1.314-.7-.496-1.165-.127-1.678-.816-.513-.688-.026-1.028-.301-1.842-.275-.813-.868-.789-.878-1.647-.01-.858.583-.848.839-1.667.255-.82-.239-1.148.258-1.849.496-.7.97-.343 1.658-.856.689-.513.482-1.069 1.296-1.344.813-.275.986.293 1.844.283.752-.01.968-.448 1.56-.386z"
          paint-order="markers stroke fill"
        />
        <path
          d="M441.04 466.28c-16.592 12.356-11.61 25.757-31.208 32.38s-23.768-7.052-44.453-6.808c-20.685.243-24.532 14.013-44.281 7.852-19.748-6.16-15.084-19.675-31.962-31.637s-28.084-3.082-40.439-19.675c-12.356-16.592-.638-24.783-7.262-44.38s-20.908-19.002-21.152-39.688c-.243-20.685 14.051-20.425 20.212-40.174 6.16-19.748-5.746-27.662 6.215-44.54 11.962-16.878 23.373-8.265 39.965-20.62s11.61-25.758 31.208-32.38 23.768 7.051 44.453 6.808c20.685-.244 24.532-14.013 44.281-7.853 19.748 6.16 15.084 19.675 31.962 31.637s28.084 3.083 40.44 19.675.637 24.783 7.261 44.381c6.624 19.598 20.908 19.001 21.152 39.687.244 20.685-14.05 20.425-20.212 40.174-6.16 19.748 5.747 27.662-6.215 44.54s-23.373 8.265-39.965 20.621z"
          paint-order="markers stroke fill"
          style="font-variation-settings: normal"
          transform="matrix(.0318 0 0 .0318 .428 -3.787)"
        />
      </g>
    </symbol>
  </defs>
</svg>

<div class="mat-headline-6">Awards &amp; Honors</div>
<div id="awards-swiper">
  <div #swipe class="swiper">
    <div class="swiper-wrapper">
      @for (award of awards; track award) {
        <div fxLayout="row" class="swiper-slide">
          <div>
            <svg [ngClass]="getAwardClass(award.status)" width="100" height="100" version="2.0">
              <use href="#ag-award" />
            </svg>
          </div>
          <div class="slide-content">
            <div class="mat-headline-6" style="text-transform: uppercase">{{ award.status }}</div>
            <div class="mat-caption">{{ award.title }}</div>
            <div class="mat-headline-6">{{ award.year }}</div>
          </div>
        </div>
      }
    </div>
    <div #swipePrev class="swiper-button-prev"></div>
    <div #swipeNext class="swiper-button-next"></div>
  </div>
</div>
